// Shared by world.ts and levels.ts
export const K = 'dishes';
export const DEG = Math.PI / 180;
